import selectionContainsMark from './selectionContainsMark';

/**
 * Determines if the specified mark type is included in the
 * current selection or stored in the editor state.
 *
 * @param {Object} markType  The mark type to check.
 * @param {Object} state     The current editor state.
 *
 * @returns {boolean} Whether or not the mark type is within
 * the selection or stored in the editor state.
 *
 */
const isMarkActive = (markType, state) => {

	const containsMark = selectionContainsMark(markType, state);

	const storedMarks = state.storedMarks;

	let active;

	if (storedMarks === null) {

		active = containsMark;

	} else {

		active = Boolean(storedMarks.find((mark) => mark.type === markType));

	}

	return active;

};

export default isMarkActive;
